import React, { useEffect, useState, useContext } from "react"
import { Query } from "react-apollo"
import gql from "graphql-tag"
import Modal, { ModalContent, ModalHeader } from "../Modal"
import REMOVE_FAVORITE from "../../graphql/removeFavorite.graphql"
import AddModelFavorites from "../../components/AddModelFavorites"
import { MarketPlaceForm, TopicsForm } from "../FavoritesForm"
import AppContext from "../../shared/AppContext"
import qs from "qs"
import { FAVORITE_TYPE } from "./const"

import "./style.scss"

const isMyFavorite = gql`
  query isMyFavorite(
    $searchKeyword: String
    $vendor: String
    $sector: String
    $reportType: String
    $topicId: String
    $productId: String
  ) {
    isMyFavorite(
      searchKeyword: $searchKeyword
      vendor: $vendor
      sector: $sector
      reportType: $reportType
      topicId: $topicId
      productId: $productId
    ) {
      id
    }
  }
`

const Favorite = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedFavoriteType, setSelectedFavoriteType] = useState("")
  const { trackEvent } = useContext(AppContext)
  const queryParams = qs.parse(props.location.search, {
    ignoreQueryPrefix: true,
  })

  useEffect(() => {
    if (!isModalOpen) {
      setSelectedFavoriteType("")
    } else {
      setSelectedFavoriteType(props.favoriteType)
    }
  }, [isModalOpen])

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleClick = () => {
    if (props.data.isMyFavorite && props.data.isMyFavorite.id) {
      return props.client
        .mutate({
          mutation: REMOVE_FAVORITE,
          variables: {
            favoriteId: props.data.isMyFavorite.id,
          },
        })
        .then(() => {
          props.refetch()
          trackEvent("Deleted Favorite", {
            location: props.trackingLocation,
            modelName: props.modelName,
            favoriteType: props.favoriteType,
          })
        })
        .catch((err) => {
          console.log("Remove favorites error:", err)
        })
    }
    trackEvent("add to favorite button click", {
      location: props.trackingLocation,
      modelName: props.modelName,
      favoriteType: props.favoriteType,
    })
    openModal()
  }

  const renderChildren = () => {
    return React.cloneElement(props.children, {
      onClick: handleClick,
      isMyFavorite: !!(props.data.isMyFavorite && props.data.isMyFavorite.id),
    })
  }

  return (
    <React.Fragment>
      {renderChildren()}
      <Modal
        isOpen={isModalOpen}
        close={() => {
          setIsModalOpen(false)
          setSelectedFavoriteType("")
        }}
      >
        <ModalContent className="medium">
          <ModalHeader text="Add To Favorites" />
          {FAVORITE_TYPE.SEARCH === selectedFavoriteType && (
            <MarketPlaceForm
              favoriteData={{
                name: props.searchData.keyword,
                favoriteType: selectedFavoriteType,
                slug: "/marketplace",
                metadata: {
                  searchKeyword: queryParams.keyword,
                  vendor: queryParams.vendor,
                  sector: queryParams.sector,
                  reportType: queryParams.reportType,
                },
              }}
              favoriteType={selectedFavoriteType}
              setIsModalOpen={closeModal}
              refetch={props.refetch}
              trackingLocation={props.trackingLocation}
            />
          )}

          {FAVORITE_TYPE.REPORT === selectedFavoriteType && (
            <MarketPlaceForm
              favoriteType={props.favoriteType}
              setIsModalOpen={closeModal}
              favoriteData={props.favoriteData}
              trackingLocation={props.trackingLocation}
              refetch={props.refetch}
            />
          )}

          {props.topic && (
            <TopicsForm
              id={props.topic.id}
              type={props.topic.type}
              name={props.topic.name}
              slug={props.topic.slug}
              imageURL={props.topic.logo}
              refetch={props.refetch}
              onCloseModal={setIsModalOpen}
            />
          )}

          {FAVORITE_TYPE.MODEL === selectedFavoriteType && (
            <AddModelFavorites
              bookmark={props.bookmark}
              report={props.report}
              modelName={props.modelName}
              type={props.dataset}
              close={closeModal}
              trackingLocation={props.trackingLocation}
            />
          )}
        </ModalContent>
      </Modal>
    </React.Fragment>
  )
}

const favoriteWithData = (props) => {
  const { variables } = props
  return (
    <Query
      fetchPolicy={"network-only"}
      query={isMyFavorite}
      variables={variables}
    >
      {({ error, data, loading, refetch, client }) => {
        if (!data || error) return null
        if (loading) {
          return <div className={`favorite-button-container `}>loading...</div>
        }

        return (
          <Favorite client={client} refetch={refetch} data={data} {...props} />
        )
      }}
    </Query>
  )
}

export default favoriteWithData

Favorite.defaultProps = {
  location: () => {},
}
